import React, { useEffect, useState, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showModal, hideModal } from '../../actions/modal';

const Modal = () => {
  const dispatch = useDispatch();
  const [currentType, setCurrentType] = useState(null);
  const [CurrentComponent, setCurrentComponent] = useState(null);

  const modal = useSelector((state) => state.modal);

  let { show, type, data, shouldRefresh } = modal;

  // show = true;
  // type = 'AddressRecognition';
  // data = {};
  // document.body.classList.add("modal-open");

  useEffect(() => {
    if (type !== currentType) {
      setCurrentType(type);
    }
  }, [type]);

  useEffect(() => {
    if (!currentType) {
      setCurrentComponent(null);
    } else {
      const Current = React.lazy(() => import(`./${type}`));
      setCurrentComponent(Current);
    }
  }, [currentType]);

  useEffect(() => {
    if (shouldRefresh && !CurrentComponent) {
      dispatch(showModal(shouldRefresh, data));
    }
  }, [shouldRefresh, CurrentComponent]);

  const handleModalClose = (callback) => {
    dispatch(hideModal());
    if (callback && typeof callback === 'function') callback();
  };

  if (!show) return null;

  return (
    <Suspense fallback={<div style={{ display: 'none' }} />}>
      {CurrentComponent ? <CurrentComponent data={data} onClose={handleModalClose} /> : null}
    </Suspense>
  );
};

export default Modal;
